<template>
  <el-upload
    :action="contextPath + '/email/uploadAttachment'"
    class="upload-demo"
    :headers="headerObj"
    :on-remove="handleRemove"
    :on-success="handleSuccess"
    :before-remove="beforeRemove"
    :file-list="fileList"
    :before-upload="beforeUpload"
    :data="data"
  >
    <el-button size="small" type="primary">附件上传</el-button>
  </el-upload>
</template>
<script>
import Constant from "@/Constant.js";
import axios from "axios";
export default {
  data() {
    return {
      contextPath: Constant.contextPath,
      headerObj: {
        "Content-Type": "multipart/form-data;boundary=" + Math.random(),
      },
      fileList: [], // 上传后的文件列表
      data: {
        files: "", // 上传的二进制文件
      },
    };
  },
  methods: {
    /* uploadAttachment(e) {
      debugger
      let fileArray = e.file
      let file = fileArray
      let that = this
      let form = new FormData()
      form.append('files', file)
      let files = form
      axios({
        headers: {
          'content-type': 'multipart/form-data;boundary=' + Math.random(),
        },
        data: files,
        url: Constant.contextPath + '/email/uploadAttachment',
        method: 'post',
      })
        .then(function (response) {
          debugger
        })
        .catch(function (error) {})
    }, */
    /**
     * 文件上传成功
     */
    handleSuccess(response, file, fileList) {
      if (response.errcode == 0) {
        this.$emit("getFileId", file.uid);
        this.$message.success("成功上传附件!");
      }
    },
    /**
     * 文件列表移除文件时的钩子
     */
    handleRemove(file, fileList) {
      // 调用接口删除文件
      this.$api.deleteFile(file.uid, {
        onSucess: (res) => {
          if (res.data.errcode == 0) {
            this.$emit("subFileId", file.uid);
            this.$message.success("成功移除附件!");
          } else {
            this.$message.warning(res.data.errmsg);
          }
        },
      });
    },

    /**
     * 删除文件之前的钩子
     */
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    /**
     * 上传文件前的钩子
     */
    beforeUpload(file) {
      // 新建一个FileReader
      const reader = new FileReader();
      // 读取文件
      reader.readAsText(file, "UTF-8");
      // 读取完文件之后会回来这里
      reader.onload = (e) => {
        // 读取文件内容
        const fileString = e.target.result;
        // 接下来可对文件内容进行处理
        this.data.files = new Blob([fileString], { type: "text/plain" });
      };
    },
  },
};
</script>
